// extracted by mini-css-extract-plugin
module.exports = {"headBg":"ArchivioFascicoliTemplate_headBg__3srj4","archivioFascicoliContent":"ArchivioFascicoliTemplate_archivioFascicoliContent__XJbct"};